import React, {useState, useEffect} from 'react'
import { useLocation } from "react-router-dom";
import Banner from '../../Components/Banner'
import { cursorPointer } from '../../Components/Home/style';
import { itemPost, ItemPost } from '../../Components/Post'
import posts from '../../Constants/posts'

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function Blog() {

    const data = {
        title : 'Our Newsletter',
        description: 'Laborum accusantium libero commodi. Voluptate consequatur itaque expedita accusamus impedit perspiciatis asperiores necessitatibus assumenda magnam ipsa.',
        navigation: [{path: '/blog',title:'Newsletter'}]
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    
    let query = useQuery();
    let param = query.get('filter')
    if(param===null)
        param = ""

    const [filter, setFilter] = useState({page: 0, key: param})


    console.log('filter', filter);
    let filteredPosts = posts.filter(post => post.category.includes(filter.key))
    console.log('filtered Posts', filteredPosts);
    
    let pages = Math.trunc(filteredPosts.length/20)+1
    let renderPosts = filteredPosts.slice(filter.page*20, (filter.page+1)*20)

    function pageItem(index:number, ) {
        return <li key={index} className={filter.page===index?"knsl-active":""}><a href="#." onClick={() => setFilter({page:index, key: filter.key})}>{index+1}</a></li>
    }

    let pagesList : number[]
    pagesList = []
    for (let i = 0; i < pages; i++) {
        pagesList.push(i)
    }

    return (
        <>
            <Banner data={data} />

            <section className="knsl-p-100-100">
                <img src="assets/img/palm.svg" className="knsl-deco-left" alt="palm" />
                <div className="container">
                    <div className="knsl-filter knsl-mb-60">
                        <span style={cursorPointer} onClick={evt => setFilter({page:0, key: ''})} className={filter.key===''?"knsl-work-category knsl-current":"knsl-work-category"}>All News</span>
                        <span style={cursorPointer} onClick={evt => setFilter({page:0, key: 'news'})} className={filter.key==='news'?"knsl-work-category knsl-current":"knsl-work-category"}>News &amp; Promotions</span>
                        <span style={cursorPointer} onClick={evt => setFilter({page:0, key: 'covid'})} className={filter.key==='covid'?"knsl-work-category knsl-current":"knsl-work-category"}>Infos Covid</span>
                    </div>
                    <div className="row align-items-center">
                        {renderPosts.map((post:ItemPost) => itemPost(post,false))}
                        <div className="col-lg-12">
                            <ul className="knsl-pagination">
                                {pagesList.map(index => pageItem(index))}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Blog